@if (!xlFile) {
  <p>{{ 'PercentComplete' | translate:progressPercent }}</p>
  <soho-progress [progressValue]="progressValue"></soho-progress>
} @else {
  @for (part of partProgress; track part) {
    <div>
      <p>{{ part.partLabel + ('PercentComplete' | translate:part.partPercent) }}</p>
      <soho-progress [progressValue]="part.progress"></soho-progress>
    </div>
  }
  @if (completeUpload) {
    <div>
      <p>{{ 'CompletingUpload' | translate }}</p>
    </div>
  }
}
